module.exports = ".alert-container {\n  z-index: 12000;\n  position: absolute;\n  width: 100%;\n}\n\n.alert {\n  margin-bottom: 5px;\n  font-weight: bold;\n  -webkit-box-shadow: 0px 3px 8px -2px rgba(0, 0, 0, 0.54);\n  -moz-box-shadow: 0px 3px 8px -2px rgba(0, 0, 0, 0.54);\n  box-shadow: 0px 3px 8px -2px rgba(0, 0, 0, 0.54);\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/alert/alert.css
 ** module id = 319
 ** module chunks = 2
 **/